import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { adminAPI } from '../../../api';
import Pagination from '../../../components/Pagination';
import EditIcon from '../../../../../../assets/images/reskin-images/icon--edit.svg';
import BinIcon from '../../../../../../assets/images/reskin-images/icon--bin.svg';
import SVG from 'react-inlinesvg';
import RemoveModal from './components/DeleteModal';
import useModal from '../../../context/ModalContext';
import SimpleTable from '../../../components/SimpleTable';
import { Link } from 'react-router-dom';

const Cohorts = ({ searchQuery, filter, setOpenSideActionBoard, setRefetchCohorts }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { setContent } = useModal();

  const { data, refetch } = useQuery(
    ['getAllCohorts', { page: currentPage, search: searchQuery, filter }],
    adminAPI.getAllCohorts
  );

  useEffect(() => {
    if (setRefetchCohorts) {
      setRefetchCohorts(refetch);
    }
  }, [refetch, setRefetchCohorts]);

  const columns = [
    {
      label: 'Name',
      field: 'name',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '280px',
      onHover: (item) => (
        <div className={'flex h-full items-center gap-2'}>
          <Link
            className="flex items-center justify-content-center bg-purple-100 p-2 rounded-lg hover:bg-purple-200"
            to={`edit/${item.id}`}
          >
            <SVG src={EditIcon} />
          </Link>
          <button
            type="button"
            className="flex items-center justify-content-center bg-purple-100 hover:bg-red-lighter rounded-lg p-2"
            onClick={() => {
              setContent({
                content: <RemoveModal id={item.id} refetch={refetch} />,
              });
            }}
          >
            <SVG src={BinIcon} />
          </button>
        </div>
      ),
    },  
    {
      label: 'ID',
      field: 'id',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '80px',
    },
    {
      label: 'User Access Type',
      field: 'user_access_type',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '120px',
    },
    {
      label: 'Alex Access Type',
      field: 'alex_access_type',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '120px',
    },
    {
      label: 'Start Date',
      field: 'start_date',
      textAlign: 'center',
      fontWeight: 'semibold',
      width: '120px',
    },
    {
      label: 'User Expiration',
      field: 'user_expiration_date',
      textAlign: 'center',
      fontWeight: 'semibold',
      width: '100px',
    },
    {
      label: 'Alex Expiration',
      field: 'alex_expiration_date',
      textAlign: 'center',
      fontWeight: 'semibold',
      width: '100px',
    },
    {
      label: 'Company',
      field: 'company_name',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '150px',
    },
    {
      label: 'Participants',
      field: 'participants',
      textAlign: 'center',
      fontWeight: 'semibold',
      width: '120px',
    },
    {
      label: 'Status',
      field: 'status',
      textAlign: 'center',
      fontWeight: 'semibold',
      width: '110px',
    },

  ];

  const getStatusButton = (status) => {
    if (status === 'Active') {
      return (
        <div className="flex items-center justify-center bg-green-lightest rounded-lg px-2">
          Active
        </div>
      );
    } else if (status === 'Completed') {
      return (
        <div className="flex items-center justify-center bg-grey-lightest rounded-lg px-2">
          Completed
        </div>
      );
    } else if (status === 'Upcoming') {
      return (
        <div className="flex items-center justify-center bg-blue-lightest rounded-lg px-2">
          Upcoming
        </div>
      );
    } else if (status === 'Unconfirmed' || status === 'Pending') {
      return (
        <div className="flex items-center justify-center bg-yellow-lightest rounded-lg px-2">
          {status}
        </div>
      );
    }
    return status;
  };

  const renderRowFn = (cohort) => {
    const id = cohort?.id;

    return {
      id,
      name: (
        // <div className='flex flex-no-wrap whitespace-no-wrap items-center justify-between'>
          cohort.name
        // </div>
      ),
      user_expiration_date: cohort.user_expiration_date ? formatDate(cohort.user_expiration_date) : null, 
      alex_expiration_date: cohort.alex_expiration_date ? formatDate(cohort.alex_expiration_date) : null,
      start_date: cohort.start_date ? formatDate(cohort.start_date) : null,
      user_access_type: cohort.user_access_type,
      alex_access_type: cohort.alex_access_type,
      company_name: cohort.company_name,
      participants: cohort.participants,
      status: getStatusButton(cohort.status),
    };
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return '-';
    }
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
    };
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate.replace(/\//g, '-');
  };

  useEffect(() => {
    refetch();
  }, [currentPage, searchQuery, filter, refetch]);

  return (
    <>
      {data?.cohorts && (
        <div>
          <SimpleTable data={data?.cohorts} columns={columns} rowFormatter={renderRowFn} />
        </div>
      )}

      <div style={{ paddingTop: 20 }}>
        <Pagination
          currentPage={currentPage}
          totalPage={data?.pagination?.total_pages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default Cohorts;
